import type { NavConfig, NavPageNode } from "./navConfig";

export type NavigationProps = {
  root: NavConfig;
  loading: boolean;
  isOverFooter?: boolean;
};

// Flattened page info for navigation use
export type NavPageInfo = {
  slug: string | null;
  title: string | null;
  navigationImage: { url: string | null; title: string | null } | null;
  navigationAlternateLabel: string | null;
  navigationAccessibilityLabel: string | null;
};

/**
 * Thin resolver for the local nav config (Phase 4, R-403): the config page
 * node already carries `slug`/`image`; only the display/a11y strings resolve
 * through the `t()` label resolver (which reads `OBELIX_NAV_KEYS[id]` →
 * `ads-nav`). Maps onto the same shape the navigation renderers consume so
 * their render bodies stay untouched.
 */
export function getNavPageInfo(
  item: NavPageNode | null | undefined,
  t: (id: string) => string,
): NavPageInfo | null {
  if (!item) return null;
  const label = t(item.id);
  return {
    slug: item.slug ?? null,
    title: label,
    navigationImage: item.image ? { url: item.image, title: null } : null,
    navigationAlternateLabel: label,
    navigationAccessibilityLabel: label,
  };
}

export type SubmenuItems = readonly NavPageNode[];
